import { ButtonBasic } from "@lk-gtcom/ecomlab-components"
import minus_icon from './img/bx-minus.svg'
import { ButtonActionDrop } from '../../../Buttons/ButtonActionDrop/ButtonActionDrop';
import './SettingsRow.scss'

const SettingsRow = ({
    name,
    key,
    btnFunc,
    btns = false
}) => {

    return (
        <div className='settings-row' key={key}>
            <div className='settings-row__name'>
                {name}
            </div>
            <div className='settings-row__tools'>

                {
                    (btns || btnFunc) ?
                        <div className='settings-row__btns'>
                            {btns && <ButtonActionDrop
                                id={2}
                                btns={btns}
                            />}

                            {btnFunc && <ButtonBasic
                                grey
                                width='40px'
                                minWidth='40px'
                                text={<img src={minus_icon} />}
                                onClick={(e) => btnFunc()}
                            />}
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}

export { SettingsRow }
